import {hitGoogleTagManager} from "@pg-mono/google-tag-manager";

type PromotionTileEventAction = "view" | "click";
type PromotionTileCustomLabel = "cta" | "tile";

interface IHitPromotionTileEventParams {
    redirectPath: string;
    tilePosition: number;
    listingPage: number;
    promotionOffersCount: number;
    customLabel?: PromotionTileCustomLabel;
}

export function hitPromotionTileEvent(action: PromotionTileEventAction, params: IHitPromotionTileEventParams) {
    hitGoogleTagManager({
        event: "promotion_tile",
        event_action: action,
        custom_label: params.customLabel,
        event_label: params.redirectPath,
        event_category: params.tilePosition,
        event_category2: params.listingPage,
        event_category3: params.promotionOffersCount
    });
}
import {hitGoogleTagManager} from "@pg-mono/google-tag-manager";

type PromotionTileEventAction = "view" | "click";
type PromotionTileCustomLabel = "cta" | "tile";

interface IHitPromotionTileEventParams {
    redirectPath: string;
    tilePosition: number;
    listingPage: number;
    promotionOffersCount: number;
    customLabel?: PromotionTileCustomLabel;
}

export function hitPromotionTileEvent(action: PromotionTileEventAction, params: IHitPromotionTileEventParams) {
    hitGoogleTagManager({
        event: "promotion_tile",
        event_action: action,
        custom_label: params.customLabel,
        event_label: params.redirectPath,
        event_category: params.tilePosition,
        event_category2: params.listingPage,
        event_category3: params.promotionOffersCount
    });
}
